import protectedComponent from 'components/helpers/protectedComponent';
import action from 'common/rbac/actions';

export default protectedComponent(() => import('./CreateUser'), {
  action: action.USER_CREATE,
});
